import { render, staticRenderFns } from "./filtrosServicoBusca.vue?vue&type=template&id=51272f6a&scoped=true"
import script from "./filtrosServicoBusca.vue?vue&type=script&lang=js"
export * from "./filtrosServicoBusca.vue?vue&type=script&lang=js"
import style0 from "./filtrosServicoBusca.vue?vue&type=style&index=0&id=51272f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51272f6a",
  null
  
)

export default component.exports